import domReady from '@wordpress/dom-ready';
import Swiper from 'swiper';
import { _x } from '@wordpress/i18n';

domReady(() => {
  const imagesCarousel = document.querySelector('.expert-overview__carousel');

  if (imagesCarousel) {
    const args = {
      loop: true,
      pagination: {
        el: imagesCarousel.querySelector('.swiper-pagination'),
        clickable: true,
      },
      a11y: {
        firstSlideMessage: _x(
          'This is the first slide',
          'carousel first slide label',
          'vtx'
        ),
        lastSlideMessage: _x(
          'This is the last slide',
          'carousel first slide label',
          'vtx'
        ),
        paginationBulletMessage: _x(
          'Go to slide {{index}}',
          'carousel navigation label',
          'vtx'
        ),
        prevSlideMessage: _x(
          'Previous slide',
          'carousel previous label',
          'vtx'
        ),
        nextSlideMessage: _x('Next slide', 'carousel next label', 'vtx'),
      },
    };

    if (!document.documentElement.classList.contains('no-animation')) {
      args.autoplay = {
        delay: 2000,
        disableOnInteraction: false,
      };
    }

    const imagesSwiper = new Swiper(imagesCarousel, args);

    document.addEventListener('disable-animations', function () {
      imagesSwiper.autoplay.stop();
    });

    document.addEventListener('enable-animations', function () {
      imagesSwiper.autoplay.start();
    });
  }
});
